export type ClientTrackingCategoryType = 'language' |
    'authorisation' |
    'decline' |
    'confirm';

export class ClientTrackingCategories {
    static readonly Language: ClientTrackingCategoryType = 'language';
    static readonly Authorisation: ClientTrackingCategoryType = 'authorisation';
    static readonly Decline: ClientTrackingCategoryType = 'decline';
    static readonly Confirm: ClientTrackingCategoryType = 'confirm';
}



// WEBPACK FOOTER //
// ./src/models/ClientTrackingCategoryType.ts